import PropTypes from 'prop-types';
import React from 'react';
import {Unveil} from '@homeaway/react-unveil';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './Logo.less';

export class Logo extends React.Component {
    static contextType = TrackingContext;

    static propTypes = {
        data: PropTypes.shape({
            image: PropTypes.string,
            link: PropTypes.string,
            text: PropTypes.string
        }),
        partnerData: PropTypes.shape({
            image: PropTypes.string,
            partnershipText: PropTypes.string,
            link: PropTypes.string,
            text: PropTypes.string
        }),
        sitePartnerData: PropTypes.shape({
            image: PropTypes.string
        })
    };

    constructor(props, context) {
        super(props, context);
        this.clickHandler = this.clickHandler.bind(this);
    }

    clickHandler() {
        const field = {
            actionlocation: 'footer.logo'
        };
        this.context.trigger('footer.link.click', field);
    }

    get siteLogo() {
        if (!this.props.data || !this.props.data.image) {
            return null;
        }

        let {image, link, text} = this.props.data;

        if (this.props.partnerData && this.props.sitePartnerData) {
            image = this.props.sitePartnerData.image;
        }

        return (
            <a className="" href={link} target={'_blank'} onClick={this.clickHandler}>
                <img src={image} alt={text} />
            </a>
        );
    }

    get affiliateText() {
        if (!this.props.partnerData) {
            return null;
        }

        let {partnershipText} = this.props.partnerData;
        return (
            <span className="partnership-text">{partnershipText}</span>
        );
    }

    get affiliateLogo() {
        if (!this.props.partnerData) {
            return null;
        }

        let {image, link, text} = this.props.partnerData;
        return (
            <a href={link} target={'_blank'} onClick={this.clickHandler}>
                <img src={image} alt={text} />
            </a>
        );
    }

    render() {
        if (!this.props.data || !this.props.data.image) {
            return null;
        }
        return (
            <Unveil className="SiteFooter__logo hidden-xs" useWindowAsScrollParent>
                {this.siteLogo}{this.affiliateText}{this.affiliateLogo}
            </Unveil>
        );
    }
}

export default Logo;
